import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import {
  AccordionSectionDesc,
  AccordionSectionTitle,
} from '../../../CustomAccordion.styles';

const NonHazCarHeader = ({ data }) => {
  const { commodity, railcarSequence, equipment_id } = data;
  const resolvedCommodity = commodity || 'N/A';
  return (
    <Box flow={5}>
      <AccordionSectionTitle>
        CAR {railcarSequence} - {equipment_id}
      </AccordionSectionTitle>
      <AccordionSectionDesc>Loaded: {resolvedCommodity}</AccordionSectionDesc>
    </Box>
  );
};

export default NonHazCarHeader;
